<template>
  <el-dialog
    :visible.sync="visible"
    :before-close="closeDialog"
    width="1000px"
    :close-on-click-modal="false"
    append-to-body
    title="电子回单"
  >
    <div style="overflow: auto; height: 500px;">
      <iframe
        v-for="(url,index) in urlList"
        :key="index"
        :src="url+'&preview=1'"
        width="100%"
        height="100%"
      ></iframe>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">关  闭</el-button>
      <el-button size="small" type="primary" @click="downLoadPdf">下  载</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'DoctorPreviewPicDialog',
    data() {
      return {
        urlList: [],
        visible: false
      }
    },
    methods: {
      open(url) {
        this.urlList = url.split(',')
        this.visible = true
      },
      closeDialog() {
        this.urlList = []
        this.visible = false
      },
      downLoadPdf(fileName = '电子回单') {
        const el = document.createElement('a');
        el.style.display = 'none';
        el.setAttribute('target', '_blank');
        fileName && el.setAttribute('download', fileName);
        el.href = this.urlList[0];
        document.body.appendChild(el);
        el.click();
        document.body.removeChild(el);
      },
    }
  }
</script>
